var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-container c-bg-white",class:{
    'c-skeleton': _vm.loading,
    'ui-opacity-32': _vm.loading,
  },attrs:{"id":"tab-container"}},[(!_vm.loading)?_c('div',{staticClass:"c-row c-horizontal-center ui-h-full"},[_c('div',{staticClass:"c-col-2 sm:c-col-6 md:c-col-12 lg:c-col-10 ui-h-full"},[_c('div',{staticClass:"c-d-flex ui-flex-row ui-flex-no-wrap ui-h-full ui-overflow-auto"},[(!_vm.isVisitorView)?_vm._l((_vm.tabs),function(tab,index){return _c('tab',{key:`tabs-${index}`,attrs:{"tab":tab}})}):_vm._e()],2)])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }